import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper";
import { Container } from "react-bootstrap";
import Image from "components/image";
import {
  title, description, heroes,
  hero, heroCard, heroBody,
  heroImage, heroContent, heroTitle,
  heroSubtitle, shadow, heroImageHover,
  heroImageStatic
} from "./style.mod.scss";
import Link from "components/link";

const Heroes = ({ data }) => {
  const settings = {
    slidesPerView: 1,
    clickable: false,
    preventClicks: true,
    modules: [Pagination, Mousewheel],
    navigation: { clickable: true },
    pagination: { clickable: true },
    speed: 800,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        clickable: false,
        preventClicks: true,
        navigation: { clickable: true },
        pagination: { clickable: true },
      },
    }


  };

  return (
    <div className={heroes} style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
      <Container>
        <h2 className={title}>{data.title}</h2>
        <h4 className={description}>{data.subtitle}</h4>
        <Swiper {...settings}>
          {
            data?.Heroes?.map((heroData) => (
              <SwiperSlide className={hero} key={heroData._key}>
                <Link to={heroData?.link}>
                  <div className={heroCard}>
                    <div className={heroBody}>
                      <Image
                        className={`${heroImage} ${(!heroData?.hoverimage) ? heroImageStatic : ""}`}
                        image={heroData?.mainimage}
                        alt={heroData?.mainimage?.alt}
                      />
                      {heroData?.hoverimage &&
                        <Image
                          className={heroImageHover}
                          image={heroData.hoverimage}
                          alt={heroData?.hoverimage?.alt}
                        />
                      }
                      <div className={heroContent}>
                        {
                          heroData?.name &&
                          <h3 className={heroTitle}>{heroData.name}</h3>
                        }
                        {
                          heroData?.position &&
                          <h5 className={heroSubtitle}>{heroData?.position}</h5>
                        }
                        {
                          heroData?.bio &&
                          <h5 className={heroSubtitle}>{heroData?.bio}</h5>
                        }
                      </div>
                      <div className={shadow}></div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))
          }
        </Swiper>
      </Container>
    </div>
  );
};

export default Heroes;
